import { defineComponent as _defineComponent } from 'vue'
import {
  AlertKPI,
  AlertKPIGroup,
  CareAlertMetric,
  WccAlertMetric,
} from '@/models/enums/AlertsEnums';
import { ConsoleEnum } from '@/models/enums/ConsoleEnum';
import { careAlertsService } from '@/services/careAlerts.service';
import { computed } from 'vue';
import { isNil, uniqueId } from '@/utils/misc';
import { ValidationRules } from '@/utils/validation';
import useVuelidate from '@vuelidate/core';
import { useI18n } from '@/composables/i18n';
import { workCenterAlertsService } from '@/services/workCenterAlerts.service';


/**
 * Field to select an alert KPI (metric).
 *
 * Emits 'input' and 'change' events with the selected value when the selection
 * changes.
 */
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AlertsMetricsSelect',
  props: {
    value: null,
    console: null,
    disabled: { type: Boolean, default: false },
    flatten: { type: Boolean, default: false },
    validationRules: { default: () => ({}) }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: AlertKPI<CareAlertMetric | WccAlertMetric>) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: AlertKPI<CareAlertMetric | WccAlertMetric> | null, console: ConsoleEnum, disabled: boolean, flatten: boolean, validationRules: ValidationRules };





const { t } = useI18n();

const componentId = uniqueId();

const metric = computed({
  get() {
    return isNil(props.value) ? undefined : props.value;
  },
  set(newValue) {
    emit('input', newValue!);
  },
});

const validations = {
  metric: props.validationRules,
};
const v$ = useVuelidate(validations, { metric });

const selectedKpiOrDefault = computed(() => metric.value?.kpi);

const groups = computed((): AlertKPIGroup<CareAlertMetric | WccAlertMetric>[] =>
  props.console === ConsoleEnum.WCC
    ? workCenterAlertsService.store.kpiGroups()
    : careAlertsService.store.kpiGroups(),
);

const required = computed(() => 'required' in props.validationRules);

const validationMessage = computed(() => v$.value.metric.$errors[0]?.$message);

return { __sfc: true,props, emit, t, componentId, metric, validations, v$, selectedKpiOrDefault, groups, required, validationMessage }
}

})